import { render, staticRenderFns } from "./SampleView.vue?vue&type=template&id=6973d2ae&scoped=true&"
import script from "./SampleView.vue?vue&type=script&lang=js&"
export * from "./SampleView.vue?vue&type=script&lang=js&"
import style0 from "./SampleView.vue?vue&type=style&index=0&id=6973d2ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6973d2ae",
  null
  
)

export default component.exports